/* ═══════════════════════════════════════════
   KA Generation API client
   ═══════════════════════════════════════════ */

import { apiClient } from './client'
import type {
  KAGenDocument,
  KAGenDocSummary,
  CreateKAGenDto,
  UpdateKAGenDto,
  KAGenCodesResponse,
  AllocateKAGenDto,
  RegenerateKAGenDto,
  KAGenAllocationResult,
} from '@/types'

export const kaGenerationApi = {
  getAll: (params?: { page?: number; per_page?: number }) =>
    apiClient.get<{ data: KAGenDocSummary[]; total: number; page: number; per_page: number }>(
      '/api/ka-generation',
      { params },
    ),

  getById: (id: string) =>
    apiClient.get<KAGenDocument>(`/api/ka-generation/${id}`),

  create: (data: CreateKAGenDto) =>
    apiClient.post<KAGenDocument>('/api/ka-generation', data),

  update: (id: string, data: UpdateKAGenDto) =>
    apiClient.put<KAGenDocument>(`/api/ka-generation/${id}`, data),

  delete: (id: string) =>
    apiClient.delete(`/api/ka-generation/${id}`),

  generate: (id: string) =>
    apiClient.post<KAGenDocument>(`/api/ka-generation/${id}/generate`),

  loadFromFile: (id: string, formData: FormData) =>
    apiClient.post<KAGenDocument>(`/api/ka-generation/${id}/load-file`, formData),

  getCodes: (id: string, params?: { type?: string; page?: number; per_page?: number; pallet_num?: number }) =>
    apiClient.get<KAGenCodesResponse>(`/api/ka-generation/${id}/codes`, { params }),

  allocate: (id: string, data: AllocateKAGenDto) =>
    apiClient.post<KAGenAllocationResult>(`/api/ka-generation/${id}/allocate`, data),

  regenerate: (id: string, data?: RegenerateKAGenDto) =>
    apiClient.post<KAGenDocument>(`/api/ka-generation/${id}/regenerate`, data),

  getAllocation: (id: string, taskId: string) =>
    apiClient.get<KAGenAllocationResult>(`/api/ka-generation/${id}/allocation/${taskId}`),

  exportCsvUrl: (id: string) => `/api/ka-generation/${id}/export/csv`,

  exportExcelUrl: (id: string) => `/api/ka-generation/${id}/export/excel`,
}
